import { axios } from './axios';
import { handleErrors } from './utils';

const BASE_PATH = '/mailing/v2/provider/sender';

export function listSenders() {
    return new Promise((resolve, reject) => {
        axios
            .get(BASE_PATH)
            .then((response) => resolve(response.data))
            .catch(handleErrors(reject));
    });
}

export function createSender(data) {
    return new Promise((resolve, reject) => {
        axios
            .post(BASE_PATH, data)
            .then((response) => resolve(response.data))
            .catch(handleErrors(reject));
    });
}

export function updateSender(id, data) {
    return new Promise((resolve, reject) => {
        axios
            .put(`${BASE_PATH}/${id}`, data)
            .then((response) => resolve(response.data))
            .catch(handleErrors(reject));
    });
}
